import React, { useState, useEffect } from 'react';
import { getLocalizedDate } from 'modules/localized-date';
import PropTypes from 'prop-types';
import styles from './style.module.scss';
import posed from 'react-pose';
import { SlideUp } from 'components/animations';
import lutronLogo from './lutron-logo.png';
import orlunaLogo from './orluna-logo.png';

const Title = posed.h3({
  enter: {
    x: '0',
    delayChildren: 350,
    staggerChildren: 150,
  },
});

const TitlePart = posed.span({
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 300,
      ease: 'easeIn',
    },
  },
  exit: { y: 20, opacity: 0 },
});

const Image = posed.img({
  enter: {
    opacity: 1,
    delay: 1200,
    transition: {
      duration: 400,
      ease: 'easeIn',
    },
  },
  exit: { opacity: 0 },
});

export const NewsHero = ({ image, title, date }) => {
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    setEntered(true);
  }, []);

  return (
    <section
      className={
        `${styles['news-hero']} section container` +
        (title.toLowerCase().indexOf('lutron') > -1
          ? ' ' + styles['special-news']
          : '')
      }
      style={{
        justifyContent:
          title.toLowerCase().indexOf('lutron') > -1 ? 'start' : 'flex-end',
      }}
    >
      {title.toLowerCase().indexOf('lutron') > -1 ? (
        <div className={styles['special-news-content']}>
          {false && (
            <Title pose={entered ? 'enter' : 'exit'}>
              <TitlePart>the</TitlePart> <TitlePart>natural</TitlePart>{' '}
              <TitlePart>joining</TitlePart> <TitlePart>of</TitlePart>
            </Title>
          )}
          <div class={styles['lutron-logos']}>
            <Image pose={entered ? 'enter' : 'exit'} src={lutronLogo} />{' '}
            <span></span>{' '}
            <Image pose={entered ? 'enter' : 'exit'} src={orlunaLogo} />
          </div>
          <SlideUp delay="10000">
            <h4>a seamless harmony of lighting and controls</h4>
          </SlideUp>
        </div>
      ) : (
        <div className={`${styles.wrapper}`}>
          <div className={styles['image-wrapper']}>
            <img src={image} alt={`${title}`} />
            <div className={styles.overlay} />
          </div>

          <div
            className={styles['text-container']}
            style={{
              maxWidth:
                title.toLowerCase().indexOf('lutron') > -1 ? 'none' : '33%',
            }}
          >
            <div className={styles['text-wrapper']}>
              <h1 className={styles.title}>{title}</h1>
              <p className={styles.date}>{getLocalizedDate(date)}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

NewsHero.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
};
